import $ from 'domtastic'




/* NAV LOGOUT LINK
----------------------------------------------------------------------------------------------------*/

export default class SubmitFormLink {

    constructor($el) {
        this.$els = {
            form : $($el).find('form'),
            link : $($el).find(`a[href="#${$($el).attr('data-link-anchor')}"]`),
        }

        this.clickHandler = (e) => { this.onClick(e) }

        this.bindEvents()
    }


    bindEvents() {
        this.$els.link.on('click', this.clickHandler)
    }




    /* Handlers
    --------------------------------------------------------- */

    onClick(e) {
        e.preventDefault()
        this.$els.form.get(0).submit()
    }




    /* Actions
    --------------------------------------------------------- */




    /* Values
    --------------------------------------------------------- */

}




/* CONSTANTS AND HELPERS
---------------------------------------------------------------------------------------------------- */



